import { getCountries } from "../../../api/countries";
import { getEmployeeNotPaiedHours, getEmployees } from "../../../api/employees";

export const REQUIRED_FIELDS = [
  { key: "amount", label: "Amount"},
  /*{
    key: "priceComponents",
    label: "Price Components",
    type: "select",
    apiResKey: "priceComponents",
    api: getPriceComponents,
    apiMeta: {type: "employee"},
    isMulti: true,
  },*/
  {
    key: "employeeId",
    label: "Employee",
    type: "select",
    apiResKey: "employees",
    api: getEmployees,
  },
];

export const NOT_REQUIRED_FIELDS = [
  { key: "description", label: "Description", type: 'textarea'},
];

const FIELDS = [...REQUIRED_FIELDS, ...NOT_REQUIRED_FIELDS];

export function calcPrice(deduction){

  let total = 0

  deduction.hours.map(h => {
    total += h.day_hours*h.basePrice + h.night_hours*h.nightPrice
  })

  /*deduction.priceComponents.forEach(p => {
    total -= p.amount_type == 'percentage' ? (total/100)*p.amount : p.amount
  })*/

  return total

}

export default FIELDS;
